module.exports = __webpack_public_path__ + "img/logo3.d8a97a48.svg";